module.exports = require('./lib/index.js')



//////////////////
// WEBPACK FOOTER
// ./~/ethereumjs-abi/index.js
// module id = 339
// module chunks = 0 1 2